import { Component, Input, OnInit } from '@angular/core';
import { ApplicationState, getSelectedAddress } from '../../../store/reducers';
import { Store } from '@ngrx/store';
import * as AddressSelectorActions from '../../../store/actions/address-selector.actions';
import { OnDestroyHookDirective } from '../../../shared/hooks';

@Component({
  selector: 'mprd-address-selector',
  templateUrl: './address-selector.component.html',
})
export class AddressSelectorComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() addresses: any[];
  @Input() showNoAddress = false;
  public selectedAddress: any;

  constructor(private store: Store<ApplicationState>) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getSelectedAddress).subscribe((data) => {
        this.selectedAddress = data;
      }),
    );
  }

  selectAddress(address) {
    this.store.dispatch(new AddressSelectorActions.SelectAddress(address));
  }
}
